import { ReactComponent as Icon } from './sun-line.svg'
import "./SunIcon.css"

export const SunIcon = ({ }) => {
    return <span className='icon-base'><Icon /></span>
}